import { DialogService } from 'primeng/dynamicdialog';
import * as FlatModels from '@medsurf/flat-models';
import { MediaLibraryComponent } from "../../../media-library/media-library.component";
import { firstValueFrom } from "rxjs";

export const openMediaDialog = (header: string,
                                dialogService: DialogService,
                                allowedTypes: FlatModels.MediaEntityModels.MediaType[],
                                selected?: FlatModels.ModalAuthorModels.SelectedMediaDialogItem) => {
  const dialog = dialogService.open(MediaLibraryComponent, {
    header,
    data: {
      isModal: true,
      multiple: false,
      allowedTypes,
      selected,
    } satisfies FlatModels.ModalAuthorModels.MediaLibraryModalData,
    width: '90%',
    height: '90%',
    maximizable: true,
    rtl: true,
  })
  return firstValueFrom<FlatModels.MediaEntityModels.Media>(dialog.onClose);
};
